import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

interface CardProps {
  title?: string;
  icon?: LucideIcon;
  id?: string;
  children: ReactNode;
}

/**
 * Section wrapper used to group related form fields. Title + icon match the
 * mockup's design language (one card per logical chunk: Effective Date,
 * Business Details, Address, etc.). Pass a Lucide icon component as `icon`.
 */
export function Card({ title, icon: Icon, id, children }: CardProps) {
  return (
    <div id={id} className="bg-white rounded-2xl shadow-md p-5 mb-4">
      {title && (
        <div className="flex items-center gap-2 text-[15px] font-semibold text-brand-navy mb-4">
          {Icon && <Icon size={18} className="shrink-0" aria-hidden="true" />}
          {title}
        </div>
      )}
      {children}
    </div>
  );
}
